import {
  Button as AntButton,
  Col,
  Row,
  Input as AntInput,
  Tag,
  Layout,
  Button,
} from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import AddProcedure from '../../components/procedures/addProcedure';
import EditModal from '../../components/procedures/editModal';
import { getNetworkProcedures } from '../../services/api/cashless-procedures';
import { showError } from '../../actions';

class NetworkProcedures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      procedures: {},
      totalRecords: 0,
      editModal: false,
      editModalData: null,
      addProcedureModal: false,
      addProcedureModalData: null,
    };
  }

  componentDidMount() {
    this.fetchNetworkProcedures(this.props.centerId);
  }

  fetchNetworkProcedures = async (centerId) => {
    try{
      const response = await getNetworkProcedures(centerId)
      console.log(response.body.data, '[response]');
      this.setState({
        procedures: response.body.data,
      });
    } catch(err) {
      this.props.showError(
        'Something went wrong!',
        'Failed to get procedures mapped to center.'
      );
    }
  };

  editProcedureDetails = (row) => {
    console.log(row, 'row');
    this.setState({
      editModal: true,
      editModalData: row.original,
    });
  };

  openAddprocedureModal = () => {
    this.setState({
      addProcedureModal: true,
    });
  };

  getColums = () => [
    {
      Header: 'Cashless Procedures Supported by Center ',
      columns: [
        {
          Header: 'Procedure Id',
          accessor: 'procedureId',
          Cell: (row) => {
            return row.original.procedureId;
          },
        },
        {
          Header: 'Procedure Name',
          accessor: 'procedureName',
          Cell: (row) => {
            return row.original.procedureName;
          },
        },
        {
          Header: 'Procedure Type',
          accessor: 'procedureType',
          Cell: (row) => {
            return row.original.procedureType.split("_")[1];
          },
        },
        {
          Header: 'Cost',
          accessor: 'procedureCost',
          Cell: (row) => {
            return row.original.cost;
          },
        },
        {
          Header: 'MRP',
          accessor: 'procedureMrp',
          Cell: (row) => {
            return row.original.mrp;
          },
        },
        {
          Header: 'Procedure Status',
          accessor: 'active',
          filterable: true,
          filterMethod: (filter, row) => {
            console.log(filter, row, '[filter]');
            if (filter.value === 'All') {
              return true;
            }
            return (row.active === 1 ? 'Active' : 'Inactive') === filter.value;
          },
          Filter: ({ filter, onChange }) => {
            return (
              <select
                onChange={(event) => onChange(event.target.value)}
                style={{ width: '100%' }}
                value={filter ? filter.value : 'All'}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                <option value="All">All</option>
              </select>
            );
          },
          Cell: (row) => {
            return (
              <Tag color={row.original.active === 1 ? 'green' : 'red'}>
                {row.original.active === 1 ? 'Active' : 'Inactive'}
              </Tag>
            );
             
          },
        },
        {
          Header: 'Actions',
          accessor: '',
          Cell: (row) => (
            <Col>
              <Button
                type="primary"
                onClick={() => this.editProcedureDetails(row)}
              >
                Edit
              </Button>
              <br />
            </Col>
          ),
        },
      ],
    },
  ];

  render() {
    return (
      <>
        <div className="justify-between">
          <AntButton onClick={this.openAddprocedureModal} type="primary">
            Add Cashless Procedure
          </AntButton>
        </div>
        <Layout style={{ marginTop: 20 }}>
          {this.state.editModal && (
            <EditModal
              modalIsOpen={this.state.editModal}
              editdata={this.state.editModalData}
              centerId={this.props.centerId}
              handleClose={() => this.setState({ editModal: false })}
              reload={() => this.fetchNetworkProcedures(this.props.centerId)}
            />
          )}
          {this.state.addProcedureModal && (
            <AddProcedure
              modalIsOpen={this.state.addProcedureModal}
              handleClose={() => {
                this.setState({ addProcedureModal: false });
              }}
              reload={() => this.fetchNetworkProcedures(this.props.centerId)}
              centerId={this.props.centerId}
              skipIds={Object.keys(this.state.procedures)}
            />
          )}
          <Row>
            <ReactTable
              data={Object.values(this.state.procedures)}
              columns={this.getColums()}
              showPaginationTop
              showPaginationBottom
              loading={this.state.loading}
            />
          </Row>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

const mapDispatchToProps = (dispatch) => ({
  showError: (title, description) => {
    dispatch(showError(title, description));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NetworkProcedures)
);
